const JSON = require('circular-json');
import { getCollaudoBot, updateCollaudoBot, deleteBot } from "../../api/collaudo"

const getData = async (params) => {
  const { cacheName, cache, firstStep, steps } = params;
  const currentStep = firstStep;
  const renderedSteps = [steps[currentStep.id]];
  const previousSteps = [steps[currentStep.id]];
  const previousStep = {};

  const collaudo = await getCollaudoBot(cacheName);

  if (cache && collaudo) {
    const data = JSON.parse(collaudo);
    const lastStep = data.renderedSteps[data.renderedSteps.length - 1];

    if (lastStep && lastStep.end) {
      console.log('collaudo already ended')
    } else {
      for (let i = 0, len = data.renderedSteps.length; i < len; i += 1) {
        const renderedStep = data.renderedSteps[i];
        // remove delay of cached rendered steps
        data.renderedSteps[i].delay = 0;
        // flag used to avoid call triggerNextStep in cached rendered steps
        data.renderedSteps[i].rendered = true;

        if (renderedStep.component) {
          const { id } = renderedStep;
          data.renderedSteps[i].component = steps[id].component;
        }
      }

      const { trigger, end, options } = data.currentStep;
      const { id } = data.currentStep;

      if (options) {
        delete data.currentStep.rendered;
      }

      // add trigger function to current step
      if (!trigger && !end) {
        if (options) {
          for (let i = 0; i < options.length; i += 1) {
            data.currentStep.options[i].trigger = steps[id].options[i].trigger;
          }
        } else {
          data.currentStep.trigger = steps[id].trigger;
        }
      }
      return data;
    }
  }

  return {
    currentStep,
    previousStep,
    previousSteps,
    renderedSteps
  };
};


const setData = async (cacheName, cachedData) => {
  const data = JSON.parse(JSON.stringify(cachedData));

  // clean components
  for (const key in data) {
    for (let i = 0, len = data[key].length; i < len; i += 1) {
      if (data[key][i].component) {
        data[key][i].component = data[key][i].id;
      }
    }
  }
  try {
    const send = JSON.stringify(data)
    await updateCollaudoBot(cacheName, send);
  } catch (error) {
    console.log(error);
  }
};

const deleteData = async (id) => {
  await deleteBot(id)
}

export { getData, setData, deleteData };
